/**
 * Placeholder for /check-in/intake/{token}.
 *
 * The real customer-facing intake page is still in design. This stub at
 * least gives anyone scanning a QR or opening the link some context rather
 * than silently dropping them into the staff app shell.
 *
 * Mounted before MsalProvider in App.tsx so unauthenticated visitors land
 * here directly — no AAD redirect, no staff session exposure.
 */

import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export const CustomerIntakePlaceholder: React.FC = () => {
  const token = window.location.pathname.replace(/^\/check-in\/intake\//, '');

  return (
    <Box
      sx={{
        // 100dvh alone breaks on older mobile browsers; 100vh is the fallback and
        // must come first (a duplicate key in one object silently drops one).
        minHeight: ['100vh', '100dvh'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
        p: 2,
      }}
    >
      <Paper sx={{ maxWidth: 480, p: 4, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
          TechSolvers Check-In
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          The online intake page isn&apos;t ready yet. Please see reception
          to complete your check-in.
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontFamily: 'monospace', wordBreak: 'break-all' }}>
          Session token: {token.slice(0, 8)}…
        </Typography>
      </Paper>
    </Box>
  );
};
